import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import { MonitoringPlasticBoxesListInterface } from "../../../../redux/interfaces/expedition.interface";
import { dateToString } from "../../../../utils/dateAndTime";

const monitoringPlasticBoxesTableStatus = [
  { value: 1, label: "Scanata de verificator" },
  { value: 2, label: "Preluata de sofer" },
  { value: 3, label: "Predata de sofer" },
  { value: 4, label: "Verificata de expeditie" },
];

const getStatusLabel = (status: any) => {
  const currentStatus = monitoringPlasticBoxesTableStatus.find(
    (item) => item.value === parseInt(status),
  );

  return currentStatus?.label;
};

export const monitoringPlasticBoxesTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Seria",
    value: "sn",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Punct de livrare",
    value: "pctDeLivr",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Ruta",
    value: "ruta",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    withFilter: monitoringPlasticBoxesTableStatus,
    minW: 125,
  },
  {
    label: "Ultima actiune",
    value: "lastAction",
    minW: 125,
  },
  {
    label: "Data operatiei",
    value: "dataStart",
    minW: 125,
  },
];

export const getMonitoringPlasticBoxesTableData: any = (
  data: MonitoringPlasticBoxesListInterface[],
) =>
  data?.map((item) => {
    return {
      id: item.idCutie,
      crudData: item,
      data: [
        {
          title: item.sn,
        },
        {
          title: item.pctDeLivr,
        },
        {
          title: item.ruta,
        },
        {
          badges: [
            {
              badgeText: getStatusLabel(item.status),
            },
          ],
        },
        {
          title: item.lastAction,
        },

        {
          badges: [
            {
              badgeText: `${dateToString(item.dataStart ?? "-")}`,
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
